import StvZahlungsweise from "../../form/dto/StvZahlungsweise";
import RkResultViewDto from "../dto/RkResultViewDto";

export default class RkCtxBo {

    paketOhneSchutzbrief?: RkResultViewDto;

    paketMitSchutzbrief?: RkResultViewDto;

    zahlungsweise?: StvZahlungsweise;



}